// extracted by mini-css-extract-plugin
export var connectionButton = "_bc-1";
export var rightPanel = "_bc-3";
export var stepDescription = "_bc-2";
export var stepIcon = "_bc-0";